import React from 'react';

export default function EduTechLanding() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h1 className="text-2xl font-semibold mb-2">Edutech Assessment</h1>
        <p className="text-gray-500">Coming soon.</p>
      </div>
    </div>
  );
}
